import { Switch } from "react-router-dom";

// Pages of the blank layout (/auth, /extra-pages). The sign in page is
// served on "/" by layouts-route.
const ExtraPages = () => {
  return <Switch></Switch>;
};

export default ExtraPages;
